import React, { useState } from "react";
import axios from "axios";
import { Heart } from "lucide-react";

const API = process.env.REACT_APP_BACKEND_URL;
const auth = () => ({ headers: { Authorization: `Bearer ${localStorage.getItem("reclaim_token")}` } });

/* Heart a signature so it sits at the top of Signatures. Optimistic, reverts on failure. */
export const FavHeart = ({ bp, onChange, size = 18 }) => {
  const [on, setOn] = useState(!!bp.favourite);
  const toggle = async (e) => {
    e.stopPropagation();
    const next = !on;
    setOn(next);
    onChange?.(bp.id, next);
    try {
      await axios.post(`${API}/api/audio-journeys/blueprints/${bp.id}/favourite`, {}, auth());
    } catch {
      setOn(!next);
      onChange?.(bp.id, !next);
    }
  };
  return (
    <button type="button" onClick={toggle} aria-pressed={on} aria-label={on ? "Remove from favourites" : "Add to favourites"}
      data-testid={`signature-fav-${bp.id}`}
      className="shrink-0 w-10 h-10 inline-flex items-center justify-center rounded-full transition-transform duration-200 active:scale-90"
      style={{ color: on ? "#d7bb7a" : "rgba(245,236,217,0.45)" }}>
      <Heart size={size} fill={on ? "currentColor" : "none"} strokeWidth={1.6} />
    </button>
  );
};
